
const eDailyNewsletterFormId = process.env.GATSBY_MARKETING_EDAILY_NEWSLETTER_FORM_ID  || '';
const retailNewsletterFormId = process.env.GATSBY_MARKETING_RETAIL_NEWSLETTER_FORM_ID  || '';
const bankingPaymentsNewsletterFormId = process.env.GATSBY_MARKETING_BANKING_PAYMENTS_NEWSLETTER_FORM_ID  || '';
const chartOfTheDayFormId = process.env.GATSBY_MARKETING_CHART_OF_THE_DAY_FORM_ID || '';


const afterSignupLink = process.env.GATSBY_AFTER_NEWSLETTER_SIGNUP_LINK;
const becomeAClient = process.env.GATSBY_BECOME_A_CLIENT;
const tosLink = process.env.GATSBY_TOS_LINK;
const privacyPolicyLink = process.env.GATSBY_PRIVACY_POLICY_LINK;

const siteBrandingURL = process.env.GATSBY_SITEBRANDING_URL;
const emarketerNewsLetter = process.env.GATSBY_NEWSLETTER_URL;
const analyticsServiceUrl = process.env.GATSBY_ANALYTICS_SERVICE_URL;
const abTestingScriptSrcUrl = process.env.GATSBY_A_B_TESTING_SCRIPT_SRC_URL;

const osanoScriptUrl = process.env.GATSBY_OSANO_SCRIPT_URL;
const doesmyCompanyPluginUrl = process.env.GATSBY_SUBSCRIPTIONS_DOES_MY_COMPANY_SUBSCRIBE_PLUGIN_URL  || '';


const searchHomepageServiceUrl = process.env.GATSBY_SEARCH_HOMEPAGE_SERVICE_URL || '';
const footerServiceUrl = process.env.GATSBY_SITEBRANDING_FOOTER_URL || '';
const chartOftheDayUrl = process.env.GATSBY_CHART_OF_THE_DAY_URL || '';


const dynamicContentTopicUrl = process.env.GATSBY_DYNAMIC_CONTENT_TOPIC_URL || '';
const dynamicContentAssetUrl = process.env.GATSBY_DYNAMIC_CONTENT_ASSET_URL || '';
const dynamicContentChartUrl = process.env.GATSBY_DYNAMIC_CONTENT_CHART_URL || '';
const dynamicContentForecastUrl = process.env.GATSBY_DYNAMIC_CONTENT_FORECAST_URL || '';

// Added for branding header and footer
const articlesServiceUrl = process.env.GATSBY_ARTICLES_SERVICE_URL || '';
const iiHomeUrl = process.env.GATSBY_SITE_URL  || '';
const numbersUrl = process.env.GATSBY_NUMBERS_SERVICE_URL  || '';
const researchTopicsUrl = process.env.GATSBY_RESEARCH_TOPICS_SERVICE_URL  || '';
const searchRootUrl = process.env.GATSBY_SEARCH_URL  || '';
const noteworthyContentServiceUrl = process.env.GATSBY_NOTEWORTHY_CONTENT_SERVICE_URL  || '' ;
const noteworthyContentApiUrl = process.env.GATSBY_NOTEWORTHY_CONTENT_API_URL  || '';
const typeaheadPluginUrl = process.env.GATSBY_TYPEAHEAD_PLUGIN_URL  || '';
const podRedirectionServiceUrl = process.env.GATSBY_POD_REDIRECTION_SERVICE_URL  || '';
const subscriptionBaseUrl = process.env.GATSBY_SUBSCRIPTION_BASE_URL  || '';
const proHomePageUrl = process.env.GATSBY_PRO_HOME_PAGE_URL  || '';

// don't need intercom app secret -- the public site doesn't care about user IDs
const intercomAppId = process.env.GATSBY_INTERCOM_APP_ID  || '';

const gaApiSecret = process.env.GATSBY_GA_API_SECRET || '';
const gaMeasurementId = process.env.GATSBY_GA_MEASUREMENT_ID || '';
const osfScriptUrl = process.env.GATSBY_OSF_SCRIPT_URL || '';
const userRegistrationLibraryUrl = process.env.GATSBY_USER_REGISTRATION_LIBRARY_URL || '';

const salesForceConfig = {
  proxyAPIUrl: process.env.GATSBY_MARKETING_SALESFORCE_PROXY_API_URL || '',
  edailyNewsletterFormId: eDailyNewsletterFormId || '',
  chartOfTheDayFormId: chartOfTheDayFormId || '',
  retailNewsletterFormId: retailNewsletterFormId || '',
  bankingPaymentsNewsletterFormId: bankingPaymentsNewsletterFormId || '',
  afterSignupLink: afterSignupLink || '' ,
  becomeAClient: becomeAClient || '' ,
  tosLink: tosLink || '' ,
  privacyPolicyLink: privacyPolicyLink || '',
};

const gamConfig = {
  gptScriptUrl: process.env.GATSBY_GAM_GPT_SCRIPT_URL || '',
  networkId: process.env.GATSBY_GAM_NETWORK_ID || '',
  parentAdUnitId: process.env.GATSBY_GAM_PARENT_AD_UNIT_ID || '',
  testAdContainer: process.env.GATSBY_GAM_TEST_AD_CONTAINER_ID || '',

  insightsRiverS1: process.env.GATSBY_GAM_INSIGHTS_RIVER_S1_ID || '',
  insightsPostS1: process.env.GATSBY_GAM_INSIGHTS_POST_S1_ID || '',
  chartsRiverS1: process.env.GATSBY_GAM_CHARTS_RIVER_S1_ID || '',
  chartsPostS1: process.env.GATSBY_GAM_CHARTS_POST_S1_ID || '',
  userEmailDomainCookieKey: process.env.GATSBY_GAM_USER_EMAILDOMAIN_COOKIE || '',

  irrelevantCategories: process.env.GATSBY_GAM_IRRELEVANT_CATEGORIES || ''
};

const commonDefaultSocialThumbnailUrl = process.env.GATSBY_COMMON_DEFAULT_SOCIAL_THUMBNAIL_URL;
const commonLdJsonLogoUrl = process.env.GATSBY_COMMON_LD_JSON_LOGO_URL;
const commonFontCssUrl = process.env.GATSBY_COMMON_FONTS_CSS_URL;
const commonTrialServiceUrl = process.env.GATSBY_COMMON_TRIAL_SERVICE_URL || '';

const freemiumExtranetId = process.env.GATSBY_FREEMIUM_EXTRANET_ID;
const contentPersonalizataionApiUrl = process.env.GATSBY_CONTENT_PERSONALIZATION_API_URL;

const freemiumOnboardingCaptchaPublicKey = process.env.GATSBY_FREEMIUM_ONBOARDING_CAPTCHA_PUBLIC_KEY;
const freemiumOnboardingIsCaptchaEnabled = process.env.GATSBY_FREEMIUM_ONBOARDING_IS_CAPTCHA_ENABLED;
const freemiumRegistrationPageId = process.env.GATSBY_FREEMIUM_REGISTRATION_PAGE_ID;

export const emConfig = {
  salesForceConfig,
  siteBrandingURL,
  becomeAClient,
  analyticsServiceUrl,
  abTestingScriptSrcUrl,
  searchHomepageServiceUrl,
  emarketerNewsLetter,
  footerServiceUrl,
  dynamicContentTopicUrl,
  dynamicContentAssetUrl,
  dynamicContentChartUrl,
  dynamicContentForecastUrl,
  chartOftheDayUrl,
  articlesServiceUrl,
  iiHomeUrl,
  numbersUrl,
  researchTopicsUrl,
  searchRootUrl,
  noteworthyContentServiceUrl,
  noteworthyContentApiUrl,
  typeaheadPluginUrl,
  podRedirectionServiceUrl,
  subscriptionBaseUrl,
  osanoScriptUrl,
  gaApiSecret,
  gaMeasurementId,
  intercomAppId,
  doesmyCompanyPluginUrl,
  gamConfig,
  osfScriptUrl,
  userRegistrationLibraryUrl,
  freemiumExtranetId,
  contentPersonalizataionApiUrl,

  commonFontCssUrl,
  commonLdJsonLogoUrl,
  commonDefaultSocialThumbnailUrl,
  commonTrialServiceUrl,

  freemiumOnboardingCaptchaPublicKey,
  freemiumOnboardingIsCaptchaEnabled,
  freemiumRegistrationPageId,
  proHomePageUrl
};
